import React from "react";
import PharmacyTabs from "./PharmacyTabs";
import PharmaDashboard from "./PharmaDashboard";

function PharmacyDashboard() {
  return (
    <>
      <div className="flex flex-col gap-3 h-[94%]">
        <div className="h-full">
          <PharmaDashboard />
        </div>
      </div>
    </>
  );
}

export default PharmacyDashboard;